var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-history"},[_c('h2',{staticClass:"order-history__title"},[_vm._v(_vm._s(_vm.$t("OrderHistory.order_history")))]),_c('OrderAccordion',{attrs:{"id":"order-accordion","content":_vm.orderHistory}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }